import { Outlet, useLocation } from 'react-router'
import { motion } from 'framer-motion'
import useHelmet from '../../utilities/hooks/helmet/useHelmet'
import { useRouteFrame } from '../frame'
const AccountLayout = () => {
    const { pathname } = useLocation()
    useHelmet('حساب کاربری')
    useRouteFrame()

    return (
        <div className="sm:w-full app-frame relative md:bg-bg-md-screen">
            <motion.div
                key={pathname}
                initial={{ opacity: 0, x: '100%' }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: '-100%' }}
                transition={{ duration: 0.2 }}
                // From `md` the slate backdrop is this frame's background, so
                // the frame must grow with the page: a fixed 100vh left every
                // long account page (مدیریت اعلان‌ها) running past it onto a
                // white strip.
                className="w-100 vh-100 md:!h-auto md:min-h-screen"
            >
                <div className=" bg-main-bg md:min-h-screen">
                    <Outlet />
                </div>
            </motion.div>
        </div>
    )
}

export default AccountLayout
